import { z } from 'zod'
import type { ResetUserTwoFactorByAdminRequest } from '../../models/ResetUserTwoFactorByAdminRequest'

export const ResetUserTwoFactorByAdminRequestDTO = z.object({
  password: z.string().min(1),
  version: z.number().int().min(1),
  revoke_other_sessions: z.boolean().optional()
})

export type ResetUserTwoFactorByAdminRequestDTO = z.infer<typeof ResetUserTwoFactorByAdminRequestDTO>

export function mapResetUserTwoFactorByAdminRequestToDTO (
  model: ResetUserTwoFactorByAdminRequest
): ResetUserTwoFactorByAdminRequestDTO {
  return {
    password: model.password,
    version: model.version,
    revoke_other_sessions: model.revokeOtherSessions ?? false
  }
}

export function mapDTOToResetUserTwoFactorByAdminRequest (
  dto: ResetUserTwoFactorByAdminRequestDTO
): ResetUserTwoFactorByAdminRequest {
  return {
    password: dto.password,
    version: dto.version,
    revokeOtherSessions: dto.revoke_other_sessions ?? false
  }
}
